module.exports = __webpack_public_path__ + "img/home_03.670b2f60.png";